<template>
  <div class="cml-submit-form">
    <h3>样品寄出</h3>
    <div
        class="form-block"
        v-for="item in formData"
        :key="item.detailId"
      >
      <el-form label-width="120px" :model="item" :rules="rules" ref="formData">
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称">
              <h4>{{item.productName}}</h4>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="寻样单编号">{{item.code}}</el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="申请日期">{{item.createDate}}</el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="数量">{{item.num}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="单位">{{item.unit}}</el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="采购备注"><span style="word-break: break-all;">{{item.forSupplierRemark}}</span></el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="要求到样日期">{{item.askArrivalTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="回复到样日期">{{item.actualArrivalTime}}</el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="备注"><span style="word-break: break-all;">{{item.supplierRemark}}</span></el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="寄出时间" prop="deliveryDate">
              <el-date-picker
                v-model="item.deliveryDate"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="选择时间"
                :picker-options="expireTimeOption"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="快递公司" prop="express">
              <el-input v-model="item.express" maxlength="30" show-word-limit class="small-input-padding"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="快递单号" prop="expressNo">
              <el-input v-model="item.expressNo" maxlength="30" show-word-limit class="small-input-padding"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="附件">
              <p class="file-list-item">
                <span
                  v-for="(el, index) in item.urlList"
                  :key="index"
                >
                <el-popover
                  placement="top-start"
                  trigger="hover"
                  popper-class="popper--upload-class popper--upload-class-detail"
                  :disabled="popoverDisabled"
                  >
                    <div>
                      <el-button type="text" icon="el-icon-view" @click="previewBtn(el)">预览</el-button>
                      <el-button type="text" icon="el-icon-download" @click="downloadFile(el)">下载</el-button>
                    </div>
                    <p slot="reference">
                      <i class="el-icon-document"></i>
                      {{ el.name }}
                    </p>
                </el-popover>
                </span>
              </p>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="item.productType === 'RAW_MATERIAL'" class="file-block" style="margin-top: 20px">
          <el-col :span="7">
            <el-form-item label="附件上传" class="upload-file-outside">
              <UploadFile
                ref="uploadMultipleRef"
                btnName="SPEC/TDS"
                :multiple="true"
                :maxSize="100"
                excelFileExtend=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
                showTips="支持DOC、DOCX、XLS、XLSX、PDF、JPEG、JPG、PNG格式文件"
                @file-list-change="arr => (item.specTdsAttachmentList = arr.map(item => ({
                  name: item.fileName,
                  url: item.fileUrl
                })))"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item class="upload-file-outside">
              <UploadFile
                ref="uploadMultipleRef"
                btnName="MSDS"
                :multiple="true"
                :maxSize="100"
                excelFileExtend=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
                showTips="支持DOC、DOCX、XLS、XLSX、PDF、JPEG、JPG、PNG格式文件"
                @file-list-change="arr => (item.msdsAttachmentList = arr.map(item => ({
                  name: item.fileName,
                  url: item.fileUrl
                })))"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item class="upload-file-outside">
              <UploadFile
                ref="uploadMultipleRef"
                btnName="COA"
                :multiple="true"
                :maxSize="100"
                excelFileExtend=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
                showTips="支持DOC、DOCX、PDF、JPEG、JPG、PNG格式文件"
                @file-list-change="arr => (item.coaAttachmentList = arr.map(item => ({
                  name: item.fileName,
                  url: item.fileUrl
                })))"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item class="upload-file-outside">
              <UploadFile
                ref="uploadMultipleRef"
                btnName="附件14"
                :multiple="true"
                :maxSize="100"
                excelFileExtend=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
                showTips="支持DOC、DOCX、PDF、JPEG、JPG、PNG格式文件"
                @file-list-change="arr => (item.file14AttachmentList = arr.map(item => ({
                  name: item.fileName,
                  url: item.fileUrl
                })))"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7" class="upload-file-outside">
            <el-form-item>
              <UploadFile
                ref="uploadMultipleRef"
                btnName="原料介绍及应用资料"
                :multiple="true"
                :maxSize="100"
                excelFileExtend=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
                showTips="支持DOC、DOCX、PDF、JPEG、JPG、PNG格式文件"
                @file-list-change="arr => (item.rawMaterialsAppAttachmentList = arr.map(item => ({
                  name: item.fileName,
                  url: item.fileUrl
                })))"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="submit-btn">
      <el-button type="primary" @click="confirmBtn">确认</el-button>
      <el-button @click="cancelBtn">取消</el-button>
    </div>
    <previewFileDialog :type="fileType" :url="fileUrl" ref="previewDialog" />
  </div>
</template>
<script>
import dayjs from 'dayjs';
import download from '@/utils/download';
import previewFileDialog from '@/components/previewFileDialog';
import UploadFile from '@/components/Upload/UploadFile.vue';

export default {
  components: {
    previewFileDialog,
    UploadFile
  },
  props: {
    formList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: () => ({
    fileType: '',
    fileUrl: '',
    popoverDisabled: false,
    formData: [],
    rules: {
      deliveryDate: [{ required: true, message: '请选择寄出时间', trigger: 'change' }],
      expressNo: [{ required: true, message: '请输入快递单号', trigger: 'blur' }],
      express: [{ required: true, message: '请输入快递公司', trigger: 'blur' }],
    },
    expireTimeOption:  {  //验证时间范围
      disabledDate: (time) => {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
  }),
  watch: {
    formList: {
      handler(item) {
        if(item.length < 1) return;
        return this.formData = item.map(item => {
          return {
            ...item,
            deliveryDate: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            express: '',
            expressNo: '',
            id: item.detailId
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    // 下载模板文件
    downloadFile({name, url}) {
      download(url, name);
    },
    // 预览文件
    previewBtn({name, url}) {
      // 隐藏popover弹窗
      this.popoverDisabled = true;
      setTimeout(() => {
        this.popoverDisabled = false;
      }, 500);
      const fileExtend = name.substring(name.lastIndexOf('.')).toLowerCase();
      const type = ['.png','.jpeg','.jpg'].includes(fileExtend) ? 'img' : 'file';
      this.fileUrl = url;
      this.fileType = fileExtend.indexOf('pdf') > -1 ? 'pdf' : type;
      this.$refs.previewDialog.dialogVisible = true;
    },
    confirmBtn() {
      let arr = [];
      this.$refs.formData.map(item => {
        return item.validate(valid => {
          arr.push(valid);
        })
      });
      // 校验必填项
      if(!arr.every(Boolean)) return false;
      // 校验寄出时间
      let errArr = this.formData.filter(item => dayjs(item.createDate).diff(dayjs(item.deliveryDate)) > 0);
      if(errArr.length > 0) {
        this.$message.error(`产品名称【${errArr[0].productName}】的寄出时间不能早于申请时间`);
        return;
      }
      this.$http.outsideSampleManage.batchAddDeliveryInfo(this.formData).then(result => {
        this.$message.success(result.msg);
        this.$emit('success');
      }).catch(err => {
        this.$message.error(err.msg);
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    cancelBtn() {
      this.$emit('cancel');
    }
  }
}
</script>
<style lang="less">
.file-block .el-col .el-form-item{
  margin-bottom: 20px !important;
}
.upload-file-outside {
  .upload-tips-text {
    width: 160px;
    top: 0;
  }
}
</style>